import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './CookieBanner.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.auroragh.com/api';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('aurora_cookie_consent');
    if (!consent) {
      setTimeout(() => setVisible(true), 1500);
    }
  }, []);

  const getOrCreateVisitorId = () => {
    let visitorId = localStorage.getItem('aurora_visitor_id');
    if (!visitorId) {
      visitorId = uuidv4();
      localStorage.setItem('aurora_visitor_id', visitorId);
    }
    return visitorId;
  };

  const saveConsent = async (analyticsVal, marketingVal) => {
    setSaving(true);
    const visitorId = getOrCreateVisitorId();
    try {
      await fetch(`${API_BASE}/cookie-consent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          visitorId,
          analytics: analyticsVal,
          marketing: marketingVal,
        }),
      });
      localStorage.setItem('aurora_cookie_consent', JSON.stringify({
        analytics: analyticsVal,
        marketing: marketingVal,
        date: new Date().toISOString(),
      }));
    } catch (e) {
      localStorage.setItem('aurora_cookie_consent', JSON.stringify({
        analytics: analyticsVal,
        marketing: marketingVal,
        date: new Date().toISOString(),
      }));
    } finally {
      setSaving(false);
      setVisible(false);
    }
  };

  const handleAcceptAll = () => saveConsent(true, true);
  const handleDeclineAll = () => saveConsent(false, false);
  const handleSavePreferences = () => saveConsent(analytics, marketing);

  if (!visible) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-banner">
        <div className="cookie-header">
          <div className="cookie-icon">🍪</div>
          <div>
            <h3 className="cookie-title">We use cookies</h3>
            <p className="cookie-subtitle">
              Aurora Seafood uses cookies to improve your experience and
              personalize content.
            </p>
          </div>
        </div>

        {showDetails && (
          <div className="cookie-details">
            <div className="cookie-option">
              <div className="cookie-option-info">
                <p className="cookie-option-name">Necessary</p>
                <p className="cookie-option-desc">
                  Required for the website to function. Cannot be disabled.
                </p>
              </div>
              <div className="cookie-toggle cookie-toggle--locked">
                <span>Always on</span>
              </div>
            </div>

            <div className="cookie-option">
              <div className="cookie-option-info">
                <p className="cookie-option-name">Analytics</p>
                <p className="cookie-option-desc">
                  Helps us understand how visitors use our site via Google Analytics.
                </p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(e) => setAnalytics(e.target.checked)}
                />
                <span className="toggle-slider" />
              </label>
            </div>

            <div className="cookie-option">
              <div className="cookie-option-info">
                <p className="cookie-option-name">Marketing</p>
                <p className="cookie-option-desc">
                  Used to show relevant promotions and offers from Aurora Seafood.
                </p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                />
                <span className="toggle-slider" />
              </label>
            </div>
          </div>
        )}

        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn--ghost"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? 'Hide details' : 'Customize'}
          </button>
          <button
            className="cookie-btn cookie-btn--outline"
            onClick={handleDeclineAll}
            disabled={saving}
          >
            Decline all
          </button>
          {showDetails ? (
            <button
              className="cookie-btn cookie-btn--solid"
              onClick={handleSavePreferences}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save preferences'}
            </button>
          ) : (
            <button
              className="cookie-btn cookie-btn--solid"
              onClick={handleAcceptAll}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Accept all'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;